import { keepDocumentTitleLocalized } from "./document-title";
import { initializeErrorReportingWhenConfigured } from "./observability/sentry";
import { initializeLocale } from "./i18n";
import { mountReactApp } from "./react/main";
import "./index.css";

initializeErrorReportingWhenConfigured();
initializeLocale(window);
keepDocumentTitleLocalized();

const rootElement = document.getElementById("app");
if (rootElement) {
  mountReactApp(rootElement);
}
